import * as ActionTypes from '../actions/actionTypes';
import {DATA_SETS} from '../Constants';

function _calculationActions(data_set) {
  const actions = [ActionTypes.CALCULATE_MCARTHUR_MK5, ActionTypes.CALCULATE_LEAFLET_80];
  switch (data_set) {
    case DATA_SETS.VESTA:
      actions.push(ActionTypes.CALCULATE_VESTA);
      break;
    case DATA_SETS.VESTA_MK2_DRY:
    case DATA_SETS.VESTA_MK2_WET:
      actions.push(ActionTypes.CALCULATE_VESTA_MK2);
      break;
    case DATA_SETS.GRASS:
    case DATA_SETS.ISP:
      actions.push(ActionTypes.CALCULATE_GRASS);
      break;
    case DATA_SETS.MALLEE_HEATH:
      actions.push(ActionTypes.CALCULATE_MALLEE_HEATH);
      break;
    case DATA_SETS.PRESCRIPTIONS:
      actions.push(ActionTypes.CALCULATE_PRESCRIPTIONS);
      break;
    default:
      break;
  }
  return actions;
}

export const orchestrateBehaviourModels = store => next => action => {
  // First complete the current action
  const result = next(action);
  const { graphs, point_data_weather, manual_weather } = store.getState();
  switch (action.type) {
    case ActionTypes.SET_BEHAVIOUR_VARIABLES:
    case ActionTypes.SET_POINT_FUEL_TYPE:
    case ActionTypes.SET_POINT_TOTAL_FUEL_LOAD:
    case ActionTypes.SELECT_DATA_SET:
    case ActionTypes.GRAPH_DATA_LOADED:
    case ActionTypes.REBUILD_GRAPH_DATA:
    case ActionTypes.SET_MANUAL_WEATHER_DATA:
    case ActionTypes.SET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE:
    case ActionTypes.RESET_MANUAL_WEATHER_DATA:
    case ActionTypes.RESET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE:
    case ActionTypes.RESET_ALL_MANUAL_WEATHER_DATA:
      const actionTypes = _calculationActions(graphs.data_set);
      if (actionTypes) {
        actionTypes.forEach(actionType => {
          store.dispatch({
            type: actionType,
            data_set: graphs.data_set,
            weather_data: point_data_weather,
            modifications: manual_weather.active,
            include_history: graphs.include_history,
            short_future: graphs.short_future
          });
        });
      }
      break;
    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/behaviourModelsMiddleware.js